import { LogLevel, Configuration, RedirectRequest } from '@azure/msal-browser';

/**
 * UAT Environment Configuration
 * Azure AD Corporate Authentication only (for Microsoft employees/managers)
 */

// Azure AD Corporate Configuration - for Microsoft employees
const aadTenantId = '72f988bf-86f1-41af-91ab-2d7cd011db47'; // Microsoft corporate tenant

// Azure AD Corporate MSAL Configuration for Microsoft employees
export const msalConfigCorporate: Configuration = {
    auth: {
        clientId: '5a25faaf-115f-48b3-8640-32c03c9804d6', // Azure AD app client ID
        authority: `https://login.microsoftonline.com/${aadTenantId}`,
        redirectUri: 'https://OnboardingManager-client-uat-evbvgrgfbybje6gg.b01.azurefd.net/',
        postLogoutRedirectUri: '/',
    },
    cache: {
        cacheLocation: 'sessionStorage',
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

// Corporate scopes for Microsoft employees
const corporateScopes = [
    'api://5a25faaf-115f-48b3-8640-32c03c9804d6/user-impersonation',
    'api://5a25faaf-115f-48b3-8640-32c03c9804d6/default'
];

// Function to get login request
export const getLoginRequest = (): RedirectRequest => {
    return { scopes: corporateScopes };
};

export const loginRequest: RedirectRequest = {
    scopes: corporateScopes,
};

// UAT-specific settings
export const apiConfig = {
    baseUrl: 'https://onboarding-client-uat-ene8fvgafea4ffbg.b01.azurefd.net',
    timeout: 30000,
};

export const appConfig = {
    enableDebugMode: true,
    enableAnalytics: true,
    logLevel: LogLevel.Info,
    applicationInsightsConnectionString:
        'InstrumentationKey=42f0eb51-dba7-4e1d-aefa-7ec2b3fd810d;IngestionEndpoint=https://westus-0.in.applicationinsights.azure.com/;LiveEndpoint=https://westus.livediagnostics.monitor.azure.com/;ApplicationId=6cd2df0d-897f-4017-be89-6f73f92dc8ad',
};
